<template>
    <div>
        <loading
            :active.sync="loading.content"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Donasi</div>
            <div class="right">
                <router-link
                    :to="{ name: 'donasi.penyaluran' }"
                    class="headerButton"
                >
                    <div>
                        <p
                            style="font-size: 10px;line-height: 1.5;margin: 0;width: 60px;text-align: right;"
                        >
                            Penyaluran<br />Donasi
                        </p>
                    </div>
                    <ion-icon
                        class="icon ml-1"
                        name="receipt-outline"
                    ></ion-icon>
                </router-link>
            </div>
        </div>
        <div id="appCapsule" v-if="!loading.content">
            <div
                class="section curved-header pt-1"
                style="--height-curved:100px;"
            >
                <div class="wallet-card">
                    <div class="balance">
                        <div class="col-6 text-left">
                            <span class="title">Total Donasi</span>
                            <h1 class="total">
                                <span
                                    >Rp
                                    {{
                                        summary_donasi.donasi_terkumpul | rupiah
                                    }}</span
                                >
                            </h1>
                        </div>
                        <div class="col-6 text-right">
                            <span class="title">Donasi Anda</span>
                            <h1 class="total">
                                <span
                                    >Rp
                                    {{
                                        summary_donasi.donasi_mitra | rupiah
                                    }}</span
                                >
                            </h1>
                        </div>
                    </div>
                    <div class="wallet-footer">
                        <router-link
                            :to="{ name: 'donasi.add' }"
                            class="btn btn-primary btn-block"
                        >
                            <ion-icon name="add-circle-outline"></ion-icon>
                            Tambah Donasi
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="section mb-2" style="margin-top:50px;">
                <h3 style="margin-bottom: 5px;">Donasi dari Bertransaksi!</h3>
                <p
                    style="font-size: 12px;line-height: 150%;margin-bottom: 0px;"
                >
                    Donasi Mitra akan disalurkan di banyak bidang sosial seperti
                    Pendidikan, Kesehatan, dan Kemanusiaan.<br />
                    Kamu dapat mendonasikan Rp 1 untuk setiap transaksi yang
                    kamu lakukan serta dapat juga mendonasikannya secara
                    langsung.
                </p>
                <small style="font-weight: bold;"
                    ><i
                        >Ayo, mari bersama tebar kebaikan dengan transaksi!</i
                    ></small
                >
            </div>
            <div class="section">
                <!-- timeline -->
                <div class="timeline timed mr-2" v-if="list_donasi.length > 0">
                    <div
                        class="item mb-2"
                        v-for="item in list_donasi"
                        :key="item.id"
                    >
                        <span class="time"
                            >{{ dateDonate(item.created_at) }}<br />{{
                                dateDonateYear(item.created_at)
                            }}</span
                        >
                        <div class="dot bg-primary"></div>
                        <div class="content">
                            <h4 class="title">
                                <b style="font-weight: bold;">{{
                                    item.donatur
                                }}</b>
                                mendonasikan Rp {{ item.nominal | rupiah }}
                            </h4>
                        </div>
                    </div>
                </div>
                <!-- * timeline -->
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import $axios from './../../api.js';
    import moment from 'moment';
    moment.locale('id');
    export default {
        props: ['toast_reference'],
        data() {
            return {
                loading: {
                    content: true,
                },
                summary_donasi: {
                    donasi_terkumpul: 0,
                    donasi_mitra: 0,
                },
                list_donasi: [],
            };
        },
        created() {
            this.getSummaryDonasi();
            this.getlistDonasi();
        },
        computed: {
            ...mapState(['setting', 'toast']),
        },
        methods: {
            dateDonate(date) {
                return moment(date).format('D MMM');
            },
            dateDonateYear(date) {
                return moment(date).format('YYYY');
            },
            getSummaryDonasi() {
                $axios.get('/donasi/summary').then(response => {
                    this.summary_donasi = response.data.data;
                    this.loading.content = false;
                });
            },
            getlistDonasi() {
                $axios.get('/donasi/list').then(response => {
                    this.list_donasi = response.data.data.list_donasi;
                    this.loading.content = false;
                });
            },
        },
        mounted() {
            if (this.toast_reference != undefined) {
                this.$store.commit('SET_TOAST', this.toast_reference);
            }
        },
    };
</script>
